import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/Images/icono-realtor.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleBudgetTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY ")
], -1)
const _hoisted_2 = {
  class: "collapse mt-2",
  id: "collapseExampleBudgetTittle"
}
const _hoisted_3 = { class: "card card-body" }
const _hoisted_4 = {
  key: 0,
  class: "tw-flex tw-justify-around tw-flex-wrap tw-gap-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  id: "tablatc",
  class: "col-12 mt-4"
}
const _hoisted_8 = { class: "pb-3" }
const _hoisted_9 = { class: "table table-bordered border-0 mb-0 table-edit mb-2 mt-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "Title Company Fees and Services Payments")
  ])
], -1)
const _hoisted_11 = { class: "data" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "BUYER", -1)
const _hoisted_13 = { class: "data" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "SELLER", -1)
const _hoisted_15 = { class: "table table-bordered border-0 mb-0 table-edit mb-2 mt-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "Other items")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "ITEM"),
  /*#__PURE__*/_createElementVNode("td", null, "COST")
], -1)
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "No Title Company Found", -1)
const _hoisted_20 = [
  _hoisted_19
]

import axios from "axios";
import { ref, toRefs, onMounted, computed } from 'vue';
import { useToast } from "@/composables/useToast";
import { environment } from "@/environment";

// VARIABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTitle',
  props: {
  userSession: Object,
  usingCompanyTitle: {
    type: Object,
    default: null
  },
  isInvestment: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:usingCompanyTitle'],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast();

const url = environment.URL_API;
const loading = ref(false);
const selectedCompany = ref(null);



const { userSession, usingCompanyTitle } = toRefs(props);
const companyTitles = ref([]);
const otherItems = ref([]);

// Select a specific company to display its table
const selectCompany = (company) => {
  selectedCompany.value = company;
};

const closeSelectedCompany = () => {
  selectedCompany.value = null;
};



const setTitleCompany = async (data) => {
  emit('update:usingCompanyTitle', data);
  await toast.success(`Using ${data.name} as Title Company`, {
    position: "top-end",
    timer: 3000,
    showCloseButton: true,
  });
}


const getData = async () => {
  loading.value = true;
  const response = await axios(
    `${url}mlo/company-title?user_id=${userSession.value.iduser}&state=${userSession.value.state}&country=${userSession.value.country}&id_user=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );

  if (!response.data.error) {
    companyTitles.value = response.data.companyTitles
      ? response.data.companyTitles
      : [];

    
  }
  loading.value = false;
};
getData();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (companyTitles.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyTitles.value, (companyTitle, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "tw-mb-2"
                }, [
                  _createElementVNode("span", null, _toDisplayString(companyTitle.name), 1),
                  _createTextVNode(),
                  _hoisted_5,
                  _createElementVNode("button", {
                    class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                    onClick: ($event: any) => (selectCompany(companyTitle))
                  }, " Open ", 8, _hoisted_6)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (selectedCompany.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("td", null, _toDisplayString(selectedCompany.value.buyer) + "%", 1)
                    ]),
                    _createElementVNode("tr", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("td", null, _toDisplayString(selectedCompany.value.seller) + "%", 1)
                    ])
                  ])
                ]),
                _createElementVNode("table", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("tbody", null, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCompany.value.other_items, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.ID,
                        class: "data"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.item), 1),
                        _createElementVNode("td", null, "$ " + _toDisplayString(item.cost), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("button", {
                  class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setTitleCompany(selectedCompany.value)))
                }, " GET IT "),
                _createElementVNode("button", {
                  class: "tw-bg-gray-400 tw-px-4 tw-mt-2 tw-ml-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1",
                  onClick: closeSelectedCompany
                }, " BACK ")
              ])
            ]))
          : (companyTitles.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})